module InitAndUpdate


open Shared
open ViewTypes
open Elmish
open Fable.Remoting.Client
open Shared
open ViewTypes
open API

let update (msg: Msg) (state: State): State * Cmd<Msg> =
    SongPage.startScroll(0)
    // bij elk ander commando dan
    match msg with
    | SongMsg msg->
        match msg with
        | SongMsg.BPMClicked _ -> ()
        | _ -> SongPage.Metronome.bpmOn <- false
    | _ -> SongPage.Metronome.bpmOn <- false

    match msg with
    | DefGotData data ->
        let sortedsongs = data.Songs |> ViewLogic.sortsongs
        { state with
              Songs = sortedsongs
              Lijst = LijstInit sortedsongs
              Song = SongInit ()
              Lijsten = data.Lijsten |> ViewLogic.sortlijsten
              Agenda = AgendaInit data.Dates},
        Cmd.none
    | DefDoNothing -> state, Cmd.none
    | DefGotSong song ->
        { state with
              ViewStatus = ViewStatus.ShowSong
              Song =
                  { state.Song with
                        SelectedSong = Some song } },
        Cmd.none
    | DefLijstenUpdated lijsten ->
        { state with
              Lijsten = lijsten |> ViewLogic.sortlijsten },
        Cmd.none
    | DefSongsUpdated songs ->
        let sortedsongs = songs |> ViewLogic.sortsongs
        { state with
              Songs = sortedsongs
              Lijst = (ListPage.update (LijstMsg.UpdateAllSongs sortedsongs) state.Lijst) },
        Cmd.none
    | DefAgendaUpdated agendaitems ->
        { state with
            Agenda = {EditItem = None; StringBuffer="";EditDateOrNote=AgendaEditItem.Nothing; AgendaItems=agendaitems}}, Cmd.none
    | DefAgendaUpdatedWithNewItem agendaitems ->
        printfn "items: %A" agendaitems
        let edititem, stringbuffer =
            if agendaitems.Length>0
            then (Some (agendaitems.[0].Id)),""
            else None,""
        { state with
            Agenda = {EditItem = edititem; StringBuffer=stringbuffer;EditDateOrNote=AgendaEditItem.Date; AgendaItems=agendaitems}}, Cmd.none
    | LogoClicked ->
        {state with ViewStatus=ViewStatus.ShowAgenda}, Cmd.none
    | HamBurgerClicked -> 
        { state with
              ShowSideBar = not state.ShowSideBar },
        Cmd.none
    | AgendaMsg agendamsg -> AgendaPage.update agendamsg state
    | LijstClicked lijstId ->
        let lijst = ViewLogic.getLijst state.Lijsten lijstId
        { state with
              ViewStatus = ViewStatus.ShowLijst
              Lijst = (ListPage.update (LijstMsg.LijstClicked lijst) state.Lijst)
              Song =
                  { state.Song with
                        SelectedSong = None
                        WijzigSong = false } },
        Cmd.none
    | NieuwLijstClicked lijst ->
        if state.Song.SelectedSong.IsNone then
            { state with
                    ViewStatus= ViewStatus.ShowLijst
                    Lijst =
                      { state.Lijst with
                            SelectedLijst = Some lijst
                            WijzigLijst = true } },
            Cmd.OfAsync.perform API.bandAidApi.addLijst lijst DefLijstenUpdated
        else
            state, Cmd.none
    | ListMsg listmsg ->
        let cmd =
            match listmsg with
            | LijstMsg.SongClicked songid -> Cmd.OfAsync.perform API.bandAidApi.getSong (songid) DefGotSong
            | LijstMsg.BewaarLijstClicked ->
                state.Lijst.SelectedLijst
                |> Option.map (fun lijst -> // Deze functie om er voor te zorgen dat SongLijst geen songsbevat die niet meer bestaan
                    { lijst with
                          Created = System.DateTime.Now
                          SongLijst =
                              ListPage.lijstsongs lijst.SongLijst state.Songs
                              |> List.map (fun shortsong -> shortsong.ShortSongId) })
                |> Option.map (fun lijst -> Cmd.OfAsync.perform bandAidApi.updateLijsten lijst DefLijstenUpdated)
                |> Option.defaultValue Cmd.none
            | LijstMsg.RemoveLijstClicked ->
                state.Lijst.SelectedLijst
                |> Option.map (fun lijst -> Cmd.OfAsync.perform bandAidApi.verwijderLijst lijst DefLijstenUpdated)
                |> Option.defaultValue Cmd.none
            | LijstMsg.CancelLijstEditClicked ->
                state.Lijst.SelectedLijst
                |> Option.map (fun lijst ->
                    if lijst.Name="new list" && lijst.SongLijst.Length=0
                    then Cmd.OfAsync.perform bandAidApi.verwijderLijst lijst DefLijstenUpdated
                    else Cmd.ofMsg (LijstClicked lijst.Id))
                |> Option.defaultValue Cmd.none
            | LijstMsg.NewSongClicked song->
                Cmd.OfAsync.perform API.bandAidApi.addSong song DefSongsUpdated
            | _ -> Cmd.none

        match listmsg with
        | LijstMsg.NewSongClicked song-> // commando in listpage heeft effect op songstate, lastig
            { state with
                  ViewStatus= ViewStatus.ShowSong
                  Song =
                      { state.Song with
                            SelectedSong = Some song
                            WijzigSong = true } }, cmd
        | _ ->
            { state with
                Lijst = ListPage.update listmsg state.Lijst },cmd
    | SongMsg songmsg ->
        let cmd =
            match songmsg with
            | SongMsg.FwdClicked songid
            | SongMsg.BwdClicked songid ->
                let lijstsongs =
                    match state.Lijst.SelectedLijst with
                    | None -> state.Songs
                    | Some lijst -> ListPage.lijstsongs lijst.SongLijst state.Songs

                let index =
                    lijstsongs
                    |> List.findIndex (fun song -> song.ShortSongId = songid)

                let maxindex = lijstsongs.Length - 1
                match songmsg with
                | SongMsg.FwdClicked _ ->
                    match index = maxindex with
                    | true -> Cmd.none
                    | false -> Cmd.OfAsync.perform bandAidApi.getSong lijstsongs.[index + 1].ShortSongId DefGotSong
                | SongMsg.BwdClicked _ ->
                    match index = 0 with
                    | true -> Cmd.none
                    | false -> Cmd.OfAsync.perform bandAidApi.getSong lijstsongs.[index - 1].ShortSongId DefGotSong
                | _ -> Cmd.none
            | SongMsg.BewaarSongClicked ->
                state.Song.SelectedSong
                |> Option.map ViewLogic.camelCaseSong
                |> Option.map (fun song -> Cmd.OfAsync.perform bandAidApi.updateSongs song DefSongsUpdated)
                |> Option.defaultValue Cmd.none
            | SongMsg.CancelSongClicked ->
                state.Song.SelectedSong
                |> Option.map (fun song ->
                    match song.Name.ToLower() + song.Artist.ToLower() with
                    | "unknown titleunknown artist" -> Cmd.OfAsync.perform bandAidApi.verwijderSong song DefSongsUpdated
                    | _ -> Cmd.OfAsync.perform bandAidApi.getSong song.Id DefGotSong)
                |> Option.defaultValue Cmd.none
            | SongMsg.RemoveSongClicked ->
                state.Song.SelectedSong
                |> Option.map (fun song -> Cmd.OfAsync.perform bandAidApi.verwijderSong song DefSongsUpdated)
                |> Option.defaultValue Cmd.none
            | _ -> Cmd.none
        match songmsg with
        | SongMsg.UpClicked _ ->
            { state with
                ViewStatus=ViewStatus.ShowLijst
                Song = SongPage.update songmsg state.Song }, cmd
        | _ -> { state with Song = SongPage.update songmsg state.Song },cmd

